import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'
import './Navbar.css';
import logo from '../../assets/icons/logo/logo.jpeg';

export default function Navbar() {
    const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
    const [workDropdownOpen, setWorkDropdownOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const path = useLocation().pathname;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Get the top bar element
        const topBar = document.querySelector('.top-bar') as HTMLElement;
        const navbar = document.querySelector('.navbar') as HTMLElement;
        function toggleStickyNavbar() {
            if (topBar && navbar) {
                if (window.scrollY > topBar.offsetHeight) {
                    navbar.classList.add('nav-sticky');
                    topBar.classList.add('hide-top-bar');
                } else {
                    navbar.classList.remove('nav-sticky');
                    topBar.classList.remove('hide-top-bar');
                }
            }
        }
        window.addEventListener('scroll', toggleStickyNavbar);
    }, [])


    return (
        <>
            {/* <!-- Top Bar Start --> */}
            <div className="top-bar d-none d-lg-block">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="top-bar-branding">
                                <Link to="/" className="navbar-brand-top">
                                    <img src={logo} alt="Logo" />
                                    <span>Showbouys Foundation LBG</span>
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="top-bar-right">
                                <div className="contact-info">
                                    <div className="text">
                                        <i className="fa fa-phone"></i>
                                        <a href="tel:+233249664539"><p>+233 24 966 4539</p></a>
                                    </div>
                                    <div className="text">
                                        <i className="fa fa-envelope"></i>
                                        <a href="mailto:showbouysfoundationlbg20@gmail.com"><p>showbouys@gmail.com</p></a>
                                    </div>
                                </div>
                                <div className="social">
                                    <a href="#"><i className="fab fa-x-twitter"></i></a>
                                    <a href="https://www.facebook.com/share/1AQ51dzgeD/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                                    <a href="https://www.instagram.com/showbouysfoundationlbg?igsh=MWEyeWNqZTdpeGJreg==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                                    <a href="https://www.youtube.com/channel/UCJnaNm8Ns08rUIhsdFM2fhA" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Top Bar End --> --> */}

            {/* <!-- Nav Bar Start --> */}
            <div className="navbar navbar-expand-lg navbar-dark">
                <div className="container-fluid">
                    <div className="d-lg-none">
                        <Link to="/" className="navbar-brand">
                            <img src={logo} alt="Logo" style={{height: "32px", marginRight: "10px"}} />
                            <div className="brand-text">
                                <span className="brand-main">Showbouys</span>
                                <span className="brand-sub">Foundation LBG</span>
                            </div>
                        </Link>
                    </div>
                    <button 
                        type="button" 
                        className="navbar-toggler" 
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {menuOpen && (
                        <div 
                            className="menu-overlay d-lg-none" 
                            onClick={() => setMenuOpen(false)}
                        ></div>
                    )}
                    <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="navbarCollapse">
                        <div className="d-lg-none text-right p-3">
                            <button className="btn-close btn-close-white" onClick={() => setMenuOpen(false)} aria-label="Close"></button>
                        </div>
                        <div className="navbar-nav mr-auto">
                            <Link to="/" className={`nav-item nav-link ${path === '/' ? "active" : ""}`} onClick={() => setMenuOpen(false)}>Home</Link>
                            <div className="nav-item dropdown" onMouseEnter={() => setAboutDropdownOpen(true)} onMouseLeave={() => setAboutDropdownOpen(false)}>
                                <Link to="/about" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => {
                                    if (window.innerWidth < 992) {
                                        e.preventDefault();
                                        setAboutDropdownOpen(!aboutDropdownOpen);
                                    }
                                }}>About Us</Link>
                                <div className={aboutDropdownOpen ? "dropdown-menu show" : "dropdown-menu"}>
                                    <Link to="/about" className="dropdown-item" onClick={() => setMenuOpen(false)}>About Us</Link>
                                    <Link to="/president" className="dropdown-item" onClick={() => setMenuOpen(false)}>President</Link>
                                    <Link to="/contact" className="dropdown-item" onClick={() => setMenuOpen(false)}>Contacts</Link>
                                </div>
                            </div>
                            <Link to="/event" className={`nav-item nav-link ${path === '/event' ? "active" : ""}`} onClick={() => setMenuOpen(false)}>Events</Link>
                            <div className="nav-item dropdown" onMouseEnter={() => setWorkDropdownOpen(true)} onMouseLeave={() => setWorkDropdownOpen(false)}>
                                <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => {
                                    e.preventDefault();
                                    if (window.innerWidth < 992) {
                                        setWorkDropdownOpen(!workDropdownOpen);
                                    }
                                }}>Our Work</Link>
                                <div className={workDropdownOpen ? "dropdown-menu show" : "dropdown-menu"}>
                                    <Link to="/about" className="dropdown-item" onClick={() => setMenuOpen(false)}>What We Do</Link>
                                    <Link to="/event" className="dropdown-item" onClick={() => setMenuOpen(false)}>Projects</Link>
                                    <Link to="/contact" className="dropdown-item" onClick={() => setMenuOpen(false)}>Volunteer</Link>
                                    <hr className='dropdown-divider' />
                                    <Link to="/donate" className="dropdown-item" onClick={() => setMenuOpen(false)}>Donate Now</Link>
                                </div>
                            </div>
                            <Link to="/contact" className={`nav-item nav-link ${path === '/contact' ? "active" : ""}`} onClick={() => setMenuOpen(false)}>Contact</Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Nav Bar End --> */}
        </>
    );
}